import { render, staticRenderFns } from "./program-calc.vue?vue&type=template&id=63f75876&scoped=true&"
import script from "./program-calc.vue?vue&type=script&lang=ts&"
export * from "./program-calc.vue?vue&type=script&lang=ts&"
import style0 from "./program-calc.vue?vue&type=style&index=0&id=63f75876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f75876",
  null
  
)

export default component.exports